import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchAllocateZone = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
    return axiosInstance.get(EndPoints.EMPLOYEEALLOCATE.LIST, {
        params: {
            limit,
            page_no,
            zone_id,
            ...filter
        }
    });
}

export const fetchAllocateZoneById = (payload) => {
    const { employee_code_id } = payload;
    return axiosInstance.get(EndPoints.EMPLOYEEALLOCATE.LIST +  `/${employee_code_id}`);
}

export const createAllocateZone = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEEALLOCATE.CREATE, payload)
}

export const bulkCreateAllocateZone = (payload) => {
    return axiosInstance.post(EndPoints.EMPLOYEEALLOCATE.BULK_CREATE, payload)
}

export const updateAllocateZone = (payload) => {
    return axiosInstance.put(EndPoints.EMPLOYEEALLOCATE.UPDATE, payload)
}


export const deleteAllocateZone = (payload) => {
    const url = EndPoints.EMPLOYEEALLOCATE.DELETE + `/${payload}`
    return axiosInstance.delete(url)
}

export const downloadAllocateZoneCSV = () => {
    return axiosInstance.put(EndPoints.EMPLOYEEALLOCATE.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}